import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { UserExtraService } from '../../domain/userextra/user-extra.service';
import {
  EUserExtraActions,
  GetUserExtra,
  GetUserExtraFailure,
  UserExtraSaved,
  UserExtraSavedFailure
} from '../actions/user-extra.actions';
import { ReadNotificationsSaved } from '../actions/notifications.actions';

@Injectable()
export class UserExtraEffects {
  constructor(private userExtraService: UserExtraService) {}

  private readonly actions$ = inject(Actions);

  savedUserExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UserExtraSaved>(EUserExtraActions.UserExtraSaved),
      switchMap(action => {
        // Form user_data to store
        const userData = {
          last_read_notification: action.payload.lastReadId
        };
        return this.userExtraService.saveUserExtra(userData).pipe(
          switchMap(() => [
            new ReadNotificationsSaved({
              lastReadId: action.payload.lastReadId
            })
          ]),
          catchError(error => of(new UserExtraSavedFailure()))
        );
      }),
      catchError(error => of(new UserExtraSavedFailure()))
    )
  );

  getUserExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetUserExtra>(EUserExtraActions.GetUserExtra),
      switchMap(() =>
        this.userExtraService.getUserExtra().pipe(
          map(results => {
            // Extract last notification id from userExtra
            const lastReadId = results['user_data']
              ? JSON.parse(results['user_data']).last_read_notification
              : null;
            return new ReadNotificationsSaved({
              lastReadId: lastReadId
            });
          }),
          catchError(error => of(new GetUserExtraFailure()))
        )
      ),
      catchError(error => of(new GetUserExtraFailure()))
    )
  );
}
